import React from "react";

function Manifesto() {
  return (
    <section id="manifesto" className="section">
      <span className="eyebrow" data-reveal>
        理念 · MANIFESTO
      </span>
      <p className="manifesto-quote" data-reveal data-reveal-delay="1">
        "技术不是为了取代讲故事的人，
        <br />
        而是把<em>每一个想讲故事的人</em>
        ，送到他的观众面前。"
      </p>

      <div className="manifesto-meta">
        <div data-reveal data-reveal-delay="1">
          <span>FOUNDED</span>
          <strong>2024 · 深圳</strong>
        </div>
        <div data-reveal data-reveal-delay="2">
          <span>FOCUS</span>
          <strong>AI · 互动叙事 · 影游</strong>
        </div>
        <div data-reveal data-reveal-delay="3">
          <span>STAGE</span>
          <strong>产品上线，持续进化中</strong>
        </div>
      </div>
    </section>
  );
}

export default Manifesto;
